export const callbackActions = ($locator, app) => {
  if (app !== 'host') return {}
  return {
    runCallback({ commit, dispatch }, callbackName) {
      const { callbackHandler } = $locator
      callbackHandler.runCallbacks(callbackName)
    }
  }
}
